<app-login-theming></app-login-theming>
<app-login-layout-main-img></app-login-layout-main-img>
<app-login-layout-main-text></app-login-layout-main-text>
<div class="login-layout-main-content-container">
    <div class="login-layout-main-content">
        <router-outlet></router-outlet>
    </div>
    <app-login-footer></app-login-footer>
</div>